import React from "react";
import FadeInWrapper from "./fade-in-wrapper";

class ManagedLiftMetric extends React.PureComponent {
  render() {
    const { managedLift } = this.props;

    return (
      <div
        className="d-flex align-items-center"
        style={{ color: "#ed8936" }} // orange
      >
        {managedLift >= 0 ? (
          <div className="pr-1">
            <i
              className="fa fa-arrow-circle-o-up"
              style={{ fontSize: "18px" }}
              aria-hidden="true"
            ></i>
          </div>
        ) : (
          ""
        )}
        <FadeInWrapper key={managedLift}>
          <span style={{ fontWeight: "500" }}>
            {managedLift >= 0 ? "+" : "-"}
            {Math.abs(managedLift)}%
          </span>
        </FadeInWrapper>
      </div>
    );
  }
}

export default ManagedLiftMetric;
